import { useParams, Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

// 静的なトピックデータ（将来的にFirestoreから取得可能）
const topicsData: Record<
  string,
  {
    title: string
    description: string
    content: string
    image: string
  }
> = {
  learning: {
    title: '実践的な学びの場',
    description:
      'JITBPは、現役プロフェッショナルによる有用な実践知の共有と次世代育成を重視しています。最新技術のキャッチアップからビジネススキルの向上まで、幅広いテーマを取り上げ、参加者が実務に直結する力を磨ける環境を提供します。さらに、士業の専門家の先生方にもご協力いただき、最新の業界動向や制度改正などの知見を学びながら、実際のビジネスに活かせる知識を身につけていただきます。',
    image: '/images/service_learning opportunity-min.png',
    content: `
      <h2>実践的な学びで、スキル維持の壁を超える</h2>
      <p>
        新技術へのキャッチアップは、ITとビジネスを繋ぐ人材にとって常に大きな負担となっています。 当協会では、現役プロフェッショナルによる実践知の共有を通じて、 効率的なスキルアップと次世代育成を実現します。
      </p>
      
      <h2>主な提供内容</h2>
      <h3>IT技術・セキュリティ・ビジネススキルのアップデート</h3>
      <p>
        最新の技術トレンドやセキュリティ動向について、実務経験豊富な講師から学べます。 理論だけでなく、現場で使える実践的な知識を習得できます。
      </p>
      
      <h3>ラーニング環境の使用</h3>
      <p>
        会員は協会が提供するラーニング環境を利用し、自己開発コンテンツにアクセスできます。
      </p>
      
      <h3>コンプライアンス・自己開発</h3>
      <p>
        商習慣や標準的な企業ガイドライン、コンプライアンスなど、 個人で活動する上で必要なビジネススキルを習得できます。
      </p>
    `,
  },
  network: {
    title: 'プロフェッショナルネットワーク',
    description:
      '若手からベテランまで世代を超えた交流と相互支援。孤立の壁を超え、安心して活躍できるコミュニティを構築します。また賛助会員である法人・個人のネットワークを通じて、知財出願等、専門的な支援を必要とする会員向けに有識者を紹介します。',
    image: '/images/service_professional_network-min.png',
    content: `
      <h2>孤立の壁を超え、相互支援のネットワークを</h2>
      <p>
        個人として活動するIT人材は、同世代とのつながりが減少し、
        孤立しがちです。当協会では、若手からベテランまで世代を超えた
        交流と相互支援の場を提供します。
      </p>
      
      <h2>ネットワークの特徴</h2>
      <h3>リソースネットワーク構築</h3>
      <p>
        案件に応じて協力し合えるプロフェッショナルネットワークを構築。
        大規模案件への参画や、専門外の分野でのサポートを受けられます。
      </p>
      
      <h3>信用付与（認定制度など）</h3>
      <p>
        協会の認定制度により、個人の技術力や実績を可視化。
        企業所属でなくても信用を得られる仕組みを提供します。
      </p>
      
      <h3>世代を超えた交流</h3>
      <p>
        若手の新しい視点とベテランの経験を組み合わせることで、
        互いに学び合い、成長できる環境を実現します。
      </p>
    `,
  },
  business: {
    title: 'ビジネス機会の創出',
    description:
      '顧客の成功と社会全体のDX/AXに貢献するプロジェクト支援。個人では受けられなかった案件への参画を可能にします。',
    image: '/images/service_business opportunity-min.png',
    content: `
      <h2>キャリアの壁を超え、新たな機会を創出</h2>
      <p>
        企業所属でないと仕事を得にくい、大規模案件を請けられない――
        そんな課題を解決し、個人で活動するIT人材に新たなビジネス機会を提供します。
      </p>
      
      <h2>主な支援内容</h2>
      <h3>ビジネスインフラの使用</h3>
      <p>
        契約書の雛形、請求書システム、保険など、
        ビジネスに必要なインフラを協会として提供。
        個人では整備が難しい基盤を利用できます。
      </p>
      
      <h3>大規模案件への参画</h3>
      <p>
        協会のネットワークを活かし、個人では受けられなかった
        大規模案件にチームとして参画できます。
      </p>
      
      <h3>顧客の成功とDX/AX推進</h3>
      <p>
        誠実で高い技術を持つ人材が正しく評価される仕組みを構築し、
        顧客の成功を支えるとともに、日本社会全体のDX/AXを推進します。
      </p>
    `,
  },
}

const TopicDetailPage = () => {
  const { slug } = useParams<{ slug: string }>()
  const topic = slug ? topicsData[slug] : null
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsModalOpen(false)
      }
    }

    if (isModalOpen) {
      window.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isModalOpen])

  const breadcrumbs = topic
    ? [
        { label: 'ホーム', to: '/' },
        { label: '事業内容', to: '/#services' },
        { label: topic.title },
      ]
    : [{ label: 'ホーム', to: '/' }]

  if (!topic) {
    return (
      <>
        <Header breadcrumbs={breadcrumbs} />
        <main>
          <section className="article-detail">
            <div className="container">
              <p style={{ textAlign: 'center', padding: '4rem 0' }}>
                該当する事業内容が見つかりませんでした
              </p>
              <div style={{ textAlign: 'center' }}>
                <Link to="/" className="btn btn-outline">
                  ホームに戻る
                </Link>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    )
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <main>
        <section className="article-detail">
          <div className="container">
            <article className="article-content">
              <header className="article-header">
                <div className="article-meta">
                  <span className="article-category">事業内容</span>
                </div>
                <h1 className="article-title">{topic.title}</h1>
                <p className="article-lead">{topic.description}</p>
              </header>

              <div className="article-image-main">
                <img
                  src={topic.image}
                  alt={topic.title}
                  onClick={() => setIsModalOpen(true)}
                  style={{ cursor: 'pointer' }}
                />
              </div>

              <div
                className="article-body"
                dangerouslySetInnerHTML={{ __html: topic.content }}
              />

              <footer className="article-footer">
                <div className="article-back">
                  <Link to="/#services" className="btn btn-outline">
                    事業内容一覧に戻る
                  </Link>
                </div>
              </footer>
            </article>
          </div>
        </section>

        {isModalOpen && (
          <div
            className="image-modal-overlay"
            onClick={() => setIsModalOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              zIndex: 1000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '1rem',
            }}
          >
            <div
              style={{
                position: 'relative',
                maxWidth: '90%',
                maxHeight: '90%',
              }}
            >
              <button
                onClick={() => setIsModalOpen(false)}
                style={{
                  position: 'absolute',
                  top: '-40px',
                  right: '-10px',
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '2rem',
                  cursor: 'pointer',
                }}
              >
                &times;
              </button>
              <img
                src={topic.image}
                alt={topic.title}
                style={{
                  maxWidth: '100%',
                  maxHeight: '90vh',
                  objectFit: 'contain',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                }}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  )
}

export default TopicDetailPage

